var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-156.000000, -1176.000000) translate(140.000000, 1176.000000) translate(17.000000, 0.000000)",
    stroke: "#000",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3,8.36 C0.3,13.275 5.995,20.16 7.895,23.48 C9.795,20.16 15.49,13.275 15.49,8.36 C15.49,5.64656781 14.0424012,3.13925304 11.6925,1.78253692 C9.34259884,0.425820812 6.44740116,0.425820812 4.09749995,1.78253692 C1.74759875,3.13925304 0.3,5.64656781 0.3,8.36 L0.3,8.36 Z",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.895,
    cy: 8.655,
    r: 3.215
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.9bafe1aa4eccbe44bcb8c6928f037697.svg";
export { ForwardRef as ReactComponent };